/* file description */

import React, { FC, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Modal } from 'antd';
import { PreviewProps } from './type';

export const Preview: FC<PreviewProps> = ({ previewProps, setPreviewProps }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const closeModal = () => {
    setPreviewProps({
      visible: false,
      previewUrl: '',
      fileType: '',
    });
  };

  const onDocumentLoadSuccess = ({ numPages: page }: any) => {
    setNumPages(page);
  };

  if (!previewProps?.visible) { return <></>; }
  return (
    <Modal
      title="预览"
      width="800px"
      visible
      footer={null}
      onCancel={closeModal}
      maskClosable={false}
    >
      <div>
        {
          ['png', 'jpg', 'jpeg'].includes(previewProps?.fileType) ?
            <img style={{ width: '100%' }} src={previewProps?.previewUrl} /> : ''
        }
        {
          ['pdf'].includes(previewProps?.fileType) ?
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Document file={previewProps?.previewUrl} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
              {/* <p>
                Page {pageNumber} of {numPages}
              </p> */}
            </div> : ''
        }
      </div>
    </Modal>
  );
};
